import { useState } from "react";
import useWindowWidth from "../../hooks/useWindowWidth";
import MobileLinkViewer from "../MobileLinkViewer/MobileLinkViewer";

const LinkPreviewCard = ({ url, title, description, image, siteName, site_name, loading }) => {
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth <= 768;
  const [showOverlay, setShowOverlay] = useState(false);
  if (loading) {
    return (
      <div className="mt-2 border border-[#D7DADF] rounded-lg overflow-hidden animate-pulse">
        <div className="flex">
          <div className="w-1 bg-primaryColor flex-shrink-0" />
          <div className="flex-1 p-3 space-y-2">
            <div className="h-3 bg-gray-200 rounded w-1/4" />
            <div className="h-4 bg-gray-200 rounded w-3/4" />
            <div className="h-3 bg-gray-200 rounded w-full" />
          </div>
          <div className="w-24 h-24 bg-gray-200 flex-shrink-0" />
        </div>
      </div>
    );
  }

  if (!url) return null;

  const displaySite = siteName || site_name || (() => {
    try {
      return new URL(url).hostname.replace(/^www\./, "");
    } catch {
      return url;
    }
  })();

  const truncatedDesc = description && description.length > 120
    ? description.slice(0, 120) + "..."
    : description;

  return (
    <>
      <div
        role="link"
        tabIndex={0}
        className="mt-2 flex border border-[#D7DADF] rounded-lg overflow-hidden hover:bg-gray-50 transition-colors cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          if (isMobile && (title || description)) {
            setShowOverlay(true);
          } else {
            window.open(url, "_blank", "noopener,noreferrer");
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.stopPropagation();
            if (isMobile && (title || description)) {
              setShowOverlay(true);
            } else {
              window.open(url, "_blank", "noopener,noreferrer");
            }
          }
        }}
      >
        <div className="w-1 bg-primaryColor flex-shrink-0" />
        <div className="flex flex-1 min-w-0">
          <div className="flex-1 p-3 min-w-0">
            {displaySite && (
              <p className="text-xs text-[#888888] font-medium mb-1 truncate">{displaySite}</p>
            )}
            {title && (
              <p className="text-sm font-semibold text-black leading-snug line-clamp-2 mb-1">{title}</p>
            )}
            {truncatedDesc && (
              <p className="text-xs text-[#888888] leading-snug">{truncatedDesc}</p>
            )}
            {!title && !description && (
              <p className="text-sm text-primaryColor truncate">{url}</p>
            )}
          </div>
          {image && (
            <div className="w-24 h-24 flex-shrink-0">
              <img
                src={image}
                alt=""
                className="w-full h-full object-cover"
                onError={(e) => { e.target.parentElement.style.display = "none"; }}
              />
            </div>
          )}
        </div>
      </div>

      {showOverlay && (
        <MobileLinkViewer
          url={url}
          displaySite={displaySite}
          onClose={() => setShowOverlay(false)}
        />
      )}
    </>
  );
};

export default LinkPreviewCard;
